/* eslint @typescript-eslint/no-explicit-any: 0 */
import { omit } from "ramda";
import { curryN } from "ramda";
export default curryN(3, (a, b, x) => ({
    ...omit([a], x),
    [b]: x[a],
}));
//# sourceMappingURL=renameProp.mjs.map